
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-container">
    <giga-left-sidebar />
    <div class="giga-wrapper">
      <giga-header />
      <div id="app-content" :class="[getHasHeaderStatus ? 'has-header' : '']">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import gigaLeftSidebar from "@/layouts/components/leftSidebar";
import gigaHeader from "@/layouts/components/header";
import { mapGetters } from "vuex";
export default {
  name: "AppLayout",
  components: {
    gigaLeftSidebar,
    gigaHeader,
  },
  computed: {
    ...mapGetters("leftsidebar", ["getHasHeaderStatus"]),
  },
};
</script>

<style lang="scss">
.giga-container {
  display: flex;
  flex-wrap: wrap;
  padding: 30px;
  background-color: #f6f9fc;
  @media(min-width: 1700px){
    padding: 30px 3%;
  }
  @media(min-width: 2000px){
    padding: 30px 8%;
  }
  .giga-wrapper {
    flex: 0 0 calc(100% - 330px);
    max-width: calc(100% - 330px);
    @media(min-width: 1700px){
      padding: 20px 2%;
    }    
    @media(min-width: 2000px){
      padding: 30px 10%;
    }
    @media(max-width: 1440px){
      flex: 0 0 calc(100% - 280px);
      max-width: calc(100% - 280px);
    }
    @media(max-width: 1200px){
      flex: 0 0 calc(100% - 240px);
      max-width: calc(100% - 240px);
    }
  }
}
</style>
